import React from "react";

const sizes = {
  textxs: "text-[12px] font-medium",
  textlg: "text-[20px] font-medium",
  headingxs: "text-[12px] font-semibold",
  headings: "text-[21px] font-semibold",
  headingmd: "text-[36px] font-semibold md:text-[34px] sm:text-[32px]",
  headingmd1: "text-[45px] font-semibold md:text-[34px] sm:text-[48px]",
  headinglg: "text-[96px] font-extrabold md:text-[48px]",
};

const Heading = ({ children, className = "", size = "textlg", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`font-inter ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};


export { Heading };
